import React, { useEffect } from 'react';
import { IHealthPlanType } from '../Infrastructure/Interfaces';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../Store/StoreInit';
import HealthPlanTypePg from './HealthPlanTypePg';
import { fetchHealthPlanTypeList } from '../Store/GetDropDownsValuesReducer';

interface RootState {  
  healthPlanTypeList: {  
    healthPlanTypeList: IHealthPlanType[];  
    loading: boolean;  
  };  
}

const HealthPlanType: React.FC = () => {
  const { healthPlanTypeList, loading } = useSelector((state: RootState) => state.healthPlanTypeList);

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchHealthPlanTypeList());
  }, []);

  if (loading) {
    return (
      <div className="contentDiv">
        <h3>Loading...</h3>
      </div>
    );
  }

  if (!healthPlanTypeList) {
    return <h3>Data not found...</h3>;
  }
  return (
    <>
      <HealthPlanTypePg healthPlanTypeLists={healthPlanTypeList} />
    </>
  );
}

export default HealthPlanType;
